import { Input, Link } from "@components/core";
import { useUserAddresses } from "@hooks/use-addresses";
import { useTranslations } from "next-intl";

const HomeAddressChoice = ({ title, addAddressLink, onChange, focusedAddressId }) => {
  const t = useTranslations("addresses");

  const userAddresses = useUserAddresses();

  const buildAddressLabel = (address) => {
    const line2Display = address.line2 ? `\n${address.line2}` : "";

    return `${address.first_name} ${address.last_name}\n${address.line1}${line2Display}\n${address.zip} ${address.city}, ${address.country}`;
  };

  return (
    <div className="d-flex flex-column mt-4">
      <h6>{title}</h6>

      {userAddresses
        ?.filter((address) => address.delivery_mode === "home")
        .map((address) => (
          <div
            key={address.id}
            className="mt-3 p-3 w-100 bg-white rounded-lg"
            style={{ whiteSpace: "break-spaces" }}
          >
            <div className="d-flex">
              <Input
                id={`address-radio-${address.id}`}
                type="radio"
                checked={focusedAddressId === address.id}
                value={address.id}
                onChange={onChange}
              />
              <label
                htmlFor={`address-radio-${address.id}`}
                className="form-check-label ms-2"
                style={{ cursor: "pointer" }}
              >
                {buildAddressLabel(address)}
              </label>
              <div className="ms-auto">
                <Link
                  href={`/profile/addresses/${address.id}/edit`}
                  className="link-primary"
                  noUnderline
                >
                  {t("modify")}
                </Link>
              </div>
            </div>
          </div>
        ))}

      <Link
        href={addAddressLink}
        className="link-primary my-3 text-center"
        noUnderline
      >
        {t("add_new_address")}
      </Link>
    </div>
  );
};

export default HomeAddressChoice;
